import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

interface OwnProps {
	hasOverlaps: boolean;
	showSignatureModal: () => void;
}

const SignButton = (props: OwnProps) => {
	const { hasOverlaps, showSignatureModal } = props;

	return (
		<Button
			disabled={hasOverlaps}
			label="Sign My Time Sheet"
			onClick={showSignatureModal}
			style="secondary"
		/>
	);
};

export default SignButton;
